import React from 'react';
import { initialState } from './UIReducer';

export default React.createContext(initialState);
